<template>
  <div>
    <RideOrderingV2 />
    <div class="row mt-4">
      <div class="col-sm-6 col-12">
        <CancelRide />
        <EmergencyRideRequest />
        <DriverArrivingCall />
        <SendDriverDetails />
        <TextDriver />
      </div>
      <div class="col-sm-6 col-12">
        <CancelAutoRetryRide />
        <TextCustomer />
        <PharmacyDriverArrivingCall />
        <UberRideDestination />
        <RescanRide />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import RideOrderingV2 from './RideOrderingV2.vue';
import CancelRide from './RideOrdering/CancelRide.vue';
import CancelAutoRetryRide from './RideOrdering/CancelAutoRetryRide.vue';
import UberRideDestination from './RideOrdering/UberRideDestination.vue';
import DriverArrivingCall from './RideOrdering/DriverArrivingCall.vue';
import SendDriverDetails from './RideOrdering/SendDriverDetails.vue';
import TextDriver from './RideOrdering/TextDriver.vue';
import RescanRide from './RideOrdering/RescanRide.vue';
import PharmacyDriverArrivingCall from './RideOrdering/PharmacyDriverArrivingCall.vue';
import TextCustomer from './RideOrdering/TextCustomer.vue';
import EmergencyRideRequest from './RideOrdering/EmergencyRideRequest.vue';
</script>